import { useState } from "react";
import { Medal, Share2 } from "lucide-react";
import { QuestHeroShare } from "@/components/quest/QuestHeroShare";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const day = (d) => new Date(d).toLocaleDateString("de-DE", { timeZone: "Europe/Berlin", day: "2-digit", month: "2-digit", year: "numeric" });

export function QuestHeroBadge({ items = [], testId = "quest-hero-badge", shareUser }) {
  const [sharing, setSharing] = useState(null);
  if (!items.length) return null;
  return (
    <>
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testId} title="Aufgaben-Held"
          className="climber-badge inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[11px] font-extrabold text-amber-950 bg-gradient-to-r from-amber-200 via-yellow-400 to-amber-500 shadow-md shadow-amber-300/60 ring-1 ring-amber-300 active:scale-95 transition-transform">
          <Medal className="w-3.5 h-3.5" /> Aufgaben-Held{items.length > 1 && <span data-testid={`${testId}-count`}> ×{items.length}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-72 p-0 overflow-hidden rounded-2xl" data-testid={`${testId}-list`}>
        <p className="px-4 py-3 text-sm font-extrabold bg-gradient-to-r from-amber-100 to-yellow-50 text-amber-900 flex items-center gap-1.5"><Medal className="w-4 h-4" /> Top-Helfer bei {items.length} {items.length === 1 ? "Aufgabe" : "Aufgaben"}</p>
        <ul className="divide-y divide-amber-50 max-h-64 overflow-auto">
          {[...items].reverse().map((h) => (
            <li key={h.quest_id} className="px-4 py-2.5 flex items-center gap-3 text-sm" data-testid={`${testId}-${h.quest_id}`}>
              <span className="w-7 h-7 shrink-0 rounded-full bg-gradient-to-br from-yellow-300 to-amber-500 text-amber-950 font-extrabold text-xs flex items-center justify-center">#{h.rank}</span>
              <span className="flex-1 min-w-0"><span className="block font-bold truncate">{h.title}</span><span className="text-xs text-slate-400">{day(h.end)} · {h.total} Beiträge</span></span>
              {shareUser && <button type="button" onClick={() => setSharing(h)} data-testid={`${testId}-share-${h.quest_id}`} title="Als Story teilen" className="p-2 rounded-full text-amber-600 hover:bg-amber-50"><Share2 className="w-4 h-4" /></button>}
            </li>
          ))}
        </ul>
      </PopoverContent>
    </Popover>
    {sharing && <QuestHeroShare hero={sharing} user={shareUser} onClose={() => setSharing(null)} />}
    </>
  );
}

export function QuestHeroes({ heroes = [], testId = "quest-heroes" }) {
  if (!heroes.length) return null;
  return (
    <div className="flex flex-wrap gap-1.5" data-testid={testId}>
      {heroes.map((h) => (
        <span key={h.user_id} className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-bold bg-amber-50 text-amber-800 ring-1 ring-amber-200">
          <Medal className="w-3 h-3" /> #{h.rank} {h.name} · {h.total}×
        </span>
      ))}
    </div>
  );
}
